import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const CoachingTipsIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      id="mask0_14890_97399"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="17"
      y="10"
      width="19"
      height="24"
    >
      <path
        d="M32.5922 25.2659C34.1126 23.6523 35.0445 21.4778 35.0445 19.0857C35.0445 14.1077 31.009 10.0723 26.031 10.0723C21.053 10.0723 17.0176 14.1077 17.0176 19.0857C17.0176 21.4777 17.9494 23.6521 19.4698 25.2657C20.9902 26.8793 23.4096 33.7812 23.4096 33.7812H28.6524C28.6524 33.7812 31.0717 26.8795 32.5922 25.2659Z"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask0_14890_97399)">
      <path
        d="M32.5922 25.2659C34.1126 23.6523 35.0445 21.4778 35.0445 19.0857C35.0445 14.1077 31.009 10.0723 26.031 10.0723C21.053 10.0723 17.0176 14.1077 17.0176 19.0857C17.0176 21.4777 17.9494 23.6521 19.4698 25.2657C20.9902 26.8793 23.4096 33.7812 23.4096 33.7812H28.6524C28.6524 33.7812 31.0717 26.8795 32.5922 25.2659Z"
        fill="#B0D717"
      />
      <circle cx="22.6227" cy="17.6286" r="11.0231" fill="#DDF247" />
    </g>
    <mask
      id="mask1_14890_97399"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="22"
      y="33"
      width="8"
      height="3"
    >
      <rect x="22.623" y="33.7812" width="6.78262" height="1.50725" rx="0.753624" fill="#133C40" />
    </mask>
    <g mask="url(#mask1_14890_97399)">
      <rect x="22.623" y="33.7812" width="6.78262" height="1.50725" rx="0.753624" fill="#133C40" />
      <rect x="21.8691" y="33.0273" width="6.78262" height="1.50725" rx="0.753624" fill="#052326" />
    </g>
    <mask
      id="mask2_14890_97399"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="22"
      y="35"
      width="8"
      height="2"
    >
      <rect x="22.623" y="35.2891" width="6.78262" height="1.50725" rx="0.753624" fill="#133C40" />
    </mask>
    <g mask="url(#mask2_14890_97399)">
      <rect x="22.623" y="35.2891" width="6.78262" height="1.50725" rx="0.753624" fill="#133C40" />
      <rect x="21.8691" y="34.5352" width="6.78262" height="1.50725" rx="0.753624" fill="#052326" />
    </g>
    <mask
      id="mask3_14890_97399"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="22"
      y="36"
      width="8"
      height="3"
    >
      <rect x="22.623" y="36.7949" width="6.78262" height="1.50725" rx="0.753624" fill="#133C40" />
    </mask>
    <g mask="url(#mask3_14890_97399)">
      <rect x="22.623" y="36.7949" width="6.78262" height="1.50725" rx="0.753624" fill="#133C40" />
      <rect x="21.8691" y="36.041" width="6.78262" height="1.50725" rx="0.753624" fill="#052326" />
    </g>
    <path
      d="M23.9102 38.3027H28.1504L27.8017 39.0546C27.5548 39.5871 27.0212 39.9278 26.4343 39.9278H25.6262C25.0393 39.9278 24.5058 39.5871 24.2589 39.0546L23.9102 38.3027Z"
      fill="#052326"
    />
    <path
      d="M22.5202 21.9379C22.5202 21.9379 21.3546 17.8696 23.2064 17.6385C25.1929 17.3904 23.9995 22.0578 25.9978 21.9379C27.9246 21.8223 26.5117 17.491 28.4363 17.6385C30.2862 17.7801 29.3546 21.9379 29.3546 21.9379"
      stroke="#133C40"
      strokeWidth="0.753624"
      strokeLinecap="round"
    />
  </svg>
)
